import { useEffect, useState } from "react";

// Liste des catégories parallèles actives, SANS authentification (route
// publique — voir GET /api/parallel-categories/public dans athletes.js).
// Alimente le sélecteur des pages overlay stream. Poll lent (10s par
// défaut) : la liste des courses actives change rarement en cours
// d'événement.
export function useStreamCategories(pollMs = 10000) {
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        let cancelled = false;
        const load = () => {
            fetch("/api/parallel-categories/public")
                .then((r) => r.json())
                .then((list) => {
                    if (!cancelled) setCategories(Array.isArray(list) ? list : []);
                })
                .catch(() => {
                    /* silencieux : une page overlay ne doit jamais planter à l'écran */
                });
        };
        load();
        const timer = setInterval(load, pollMs);
        return () => {
            cancelled = true;
            clearInterval(timer);
        };
    }, [pollMs]);

    return categories;
}
